import { createSlice } from "@reduxjs/toolkit";
import { withAccessToken } from "../../server/api";
import { Chat } from "../api/chatApi";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;

const initialState = {
  token: null,
  userId: null,
  userInfo: {},
  userChatId: null,
  userChatInfo: null,
  isActiveUser: false,
  shopDomain: {},
  userChatBusinessId: null,
  idChatCurrent: null, // là id để truyền xuống chat (business || user)
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    hasDone(state, action) {
      state.isLoading = false;
    },

    updateUserLoginId(state, action) {
      const { payload } = action;
      state.userId = payload;
    },
    updateUserLoginInfo(state, action) {
      const { payload } = action;
      state.userInfo = payload;
      state.userId = payload?.id;
    },
    updateToken(state, action) {
      const { payload } = action;
      state.token = payload;
    },

    updateActiveUserChat(state, action) {
      const { payload } = action;
      state.isActiveUser = payload;
    },
    getDomainSuccess(state, action) {
      const { payload } = action;
      state.shopDomain = payload;
    },

    setUserChatBusinessId(state, action) {
      const { payload } = action;
      state.userChatBusinessId = payload;
    },
    getShopSuccess(state, action) {
      const { payload } = action;
      const userInfo = {
        id: payload?.creator_id,
        fullName: payload?.name,
        avatar: payload?.avatar,
        domain: payload?.domain,
        business_id: payload?.id,
      };
      state.userChatInfo = userInfo;
    },
    updateChatUserId(state, action) {
      const { payload } = action;
      state.userChatId = payload;
    },

    updateUserInfo(state, action) {
      const { payload } = action;
      state.userChatInfo = payload;
    },
    updateIdChatCurrent(state, action) {
      const { payload } = action;
      state.idChatCurrent = payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function receiveToken(token) {
  return (dispatch) => {
    dispatch(slice.actions.updateToken(token));
  };
}

export function getUserLoginId(userId) {
  return (dispatch) => {
    dispatch(slice.actions.updateUserLoginId(userId));
  };
}

export function setUserChatInfo(info) {
  return (dispatch) => {
    dispatch(slice.actions.updateUserInfo(info));
  };
}

export function setUserChatId(userId) {
  return (dispatch) => {
    dispatch(slice.actions.updateChatUserId(userId));
  };
}

export function getShopDomain(domain) {
  return (dispatch) => {
    dispatch(slice.actions.getDomainSuccess(domain));
  };
}
export function setUpdateIdChatCurrent(isChatCurrent) {
  return (dispatch) => {
    dispatch(slice.actions.updateIdChatCurrent(isChatCurrent));
  };
}

export function setUserChatBusinessId(userChatBusinessId) {
  return (dispatch) => {
    dispatch(slice.actions.setUserChatBusinessId(userChatBusinessId));
  };
}

export function getUserLoginInfo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Chat.authUser({
        headers: await withAccessToken({}),
      });

      const userInfo = response?.data?.user_info;
      const businessRequest = response?.data?.list_business?.find(
        (value) => value.status === "requested"
      );

      const domain = businessRequest?.domain || "";
      const businessId = businessRequest?.id || "";
      const data = {
        fullName: userInfo?.full_name,
        avatar: userInfo?.avatar,
        domain,
        is_anonymous: userInfo?.is_anonymous,
        business_id: businessId,
        id: userInfo?.id,
      };
      dispatch(slice.actions.updateUserLoginInfo(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getActiveUserChat(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });
      const response = await Chat.getActiveUserChat(
        {
          headers: config,
        },
        id
      );

      dispatch(
        slice.actions.updateActiveUserChat(response.data?.is_online || false)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getShopInfo(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      const response = await Chat.getShopInfo({
        params: params,
        headers: config,
      });
      response?.data.length &&
        dispatch(slice.actions.getShopSuccess(response?.data[0]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}
